module.exports = __webpack_public_path__ + "img/consolas.bd20e50b.svg";